export default {
  getSidebarState (state) {
    return state.isOpen;
  }
}



// WEBPACK FOOTER //
// ./app/resource/global/store/getters.js